import { render, staticRenderFns } from "./SidebarNavList.vue?vue&type=template&id=2f0b1c40&scoped=true"
import script from "./SidebarNavList.vue?vue&type=script&lang=js"
export * from "./SidebarNavList.vue?vue&type=script&lang=js"
import style0 from "./SidebarNavList.vue?vue&type=style&index=0&id=2f0b1c40&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0b1c40",
  null
  
)

export default component.exports